// extracted by mini-css-extract-plugin
module.exports = {"FileUploadContainer":"FileUpload_FileUploadContainer__TrwvS","DropzoneArea":"FileUpload_DropzoneArea__nwBAv","ImageUploadError":"FileUpload_ImageUploadError__UMUe3"};